/**
 * Guía: Tarifas de Servicio.
 *
 * Contenido derivado del capítulo **17d** del manual: §0 (qué es la tarifa,
 * que entra en el total de todas las órdenes y que se configura por niveles
 * escalonados).
 *
 * Es la línea de ingreso más transversal que existe, y por eso el primer
 * paso avisa del alcance: un cambio aquí toca el precio final de todos los
 * pedidos del país.
 */

import type { TourFlow } from '../types';

const TARIFAS_PATH = '/service-fees';

export const c17dTarifasDeServicio: TourFlow = {
  id: 'admin.service-fees',
  chapter: '17d',
  title: 'Tarifas de servicio',
  summary:
    'Lo que 121Pass le cobra al cliente en cada pedido: niveles, topes y por qué el alcance es total.',
  href: TARIFAS_PATH,
  requiresCountry: true,
  estimatedMin: 3,
  steps: [
    {
      id: 'intro',
      title: 'Entra en el total de todas las órdenes',
      body:
        'La tarifa de servicio es lo que la plataforma le cobra al cliente por usarla, y ' +
        'suma en el total de **todos** los pedidos del país. Es la línea de ingreso más ' +
        'transversal que hay.',
      route: TARIFAS_PATH,
    },
    {
      id: 'tiers',
      title: 'Se configura por niveles según el importe',
      body:
        'Por ejemplo un porcentaje hasta cierto monto y otro de ahí en adelante, y cada ' +
        'nivel admite un tope mínimo y máximo. Revisar los cortes es lo que evita que un ' +
        'pedido pequeño pague una tarifa desproporcionada.',
      target: 'admin.serviceFees.statusTabs',
      placement: 'bottom',
      optionalTarget: true,
    },
    {
      id: 'scope',
      title: 'Un cambio aquí cambia el precio final de todos',
      body:
        'No hay tarifa por comercio ni por cliente: es del país. Y como entra en el total, ' +
        'un ajuste se nota en el precio que ve cada persona al pagar.',
    },
    {
      id: 'requirement',
      title: 'Sin tarifa vigente el país no se activa',
      body:
        'Es uno de los siete requisitos. Y una archivada no cuenta: tiene que haber una ' +
        'activa.',
    },
  ],
};
